/** Automatic advisory monitoring and source catalogue. */
import type { ReactNode } from 'react';
import CsafSourcesCard from '../admin/CsafSourcesCard';

export function SystemCsafPage(): ReactNode {
  return <CsafSourcesCard />;
}

export default SystemCsafPage;
